import { lazy } from 'react'

const Main = lazy(() => import('./main'))

export default {
    Main,
}
